import React, { useEffect, useRef, useState } from 'react';
import CartValueDetails from './CartValueDetails';
import CardProductCart from './CardProductCart';
import CartEmpty from './CartEmpty';
import Button from '../../Form/Button';
import ButtonPrimary from '../../Form/ButtonPrimary';
import { useOrderTypeContext } from '../../../Contexts/OrderTypeContext';
import { HiXMark } from 'react-icons/hi2';
import { useLocation, useNavigate } from 'react-router-dom';
import { useStoreContext } from '../../../Contexts/StoreContext';
import CartService from '../../../Services/CartService';
import { useLoginContext } from '../../../Contexts/LoginContext';
import { ImSpinner8 } from 'react-icons/im';
import { useCartContext } from '../../../Contexts/CartContext';
import { useLayoutContext } from '../../../Contexts/LayoutContext';
import { TbShoppingBagPlus, TbTrash } from 'react-icons/tb';
import { CART_STATUS_FINISHED, ERROR_CART_NOT_FOUND } from '../../../Utils/Constants/Cart';
import { ORDER_STATUS_DONE } from '../../../Utils/Constants/Checkout';
import { useCartHook } from '../../../Hooks/CartHook';
import Confirm from '../Confirm';
import Modal from '../Modal';
import { useStoreHook } from '../../../Hooks/StoreHook';
import BoxContentEndScrollbars from '../BoxContentEndScrollbars';
import { ORDER_TYPE_STORE_COUNTER, ORDER_TYPE_STORE_COUNTER_ID } from '../../../Utils/Constants/Service';
import BoxContentMinimumOrderValue from './BoxContentMinimumOrderValue';
import CardBoxCheckout from '../../Layout/CardBoxCheckout';
import { useTranslation } from 'react-i18next';
import { RiCoinsFill } from 'react-icons/ri';

interface CartProps {
    onCloseCart: CallableFunction;
    onCartInfo?: CallableFunction;
    onlyInfo?: boolean;
    getCart?: any;
    enablePolling?:boolean;
    showMinimumOrderValue?: boolean;
    showButtonEditCart?: boolean;
    order?: any;
    onOpenFidelity?: any;
    loadingFidelity?: boolean;
}

const Cart = ({onCloseCart, onCartInfo, onlyInfo=false, getCart, enablePolling=false, showMinimumOrderValue=false, showButtonEditCart=false, order, onOpenFidelity, loadingFidelity}: CartProps) => {

    const { t } = useTranslation();
    const { orderType, getOrderTypeIdByName, isStoreCounter, isDelivery } = useOrderTypeContext();
    const { currentStore, setCashier } = useStoreContext();
    const { isAuthenticated, isAuthenticatedToQuickPurchase, setShowLoginBasic, user } = useLoginContext();
    const { company } = useLayoutContext();
    const { cartDisplay, setCartDisplay, setShowCart, setCartFinished, currentCart, loadingCurrentCart, loadingUpdateQuantity, setReturnToCheckout, showDoneEditingButton, setShowDoneEditingButton } = useCartContext();
    const { cartFinished, cartNotFound, removeAll } = useCartHook();
    const { getLinkToHome, storeIsOpen, getActiveCart } = useStoreHook();
    const [cart, setCart] = useState<any | null>(getCart || null)
    const [loading, setLoading] = useState<Boolean>(orderType === ORDER_TYPE_STORE_COUNTER)
    const navigate = useNavigate();
    const location = useLocation();
    const [isCheckout] = useState(location.pathname === `${getLinkToHome()}/checkout`);
    const [showConfirmResetCart, setShowConfirmResetCart] = useState(false);
    const [ isCheckoutButtonDisabled, setIsCheckoutButtonDisabled ] = useState(false);

    useEffect(() => {
        if (currentStore && !getCart?.cart_pdv_validation) {
            const orderTypeId = Number(getOrderTypeIdByName(orderType));
            if (orderTypeId !== ORDER_TYPE_STORE_COUNTER_ID) {
                const payload = {
                    store_id: currentStore.id,
                    order_type_id: orderTypeId,
                    order_type: orderType
                }
                getActiveCart(payload).catch(() => {});
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentStore, orderType]);

    const handleCheckout = () => {
        //* Verificando horários de funcionamento
        if (storeIsOpen({enableLoading: false, onlyOpeningHours: true})) {
            if (isAuthenticated || isAuthenticatedToQuickPurchase) {
                onCloseCart(false);
                navigate(`${getLinkToHome()}/checkout`);
            } else {
                //* Login básico para outros servicos (diferente do autoatendimento)
                localStorage.setItem('redirect', 'checkout');
                setShowLoginBasic(true);
                setReturnToCheckout(true);
            }
        }
    }

    const handleCartInfo = (cart: any) => {
        if (onCartInfo && isStoreCounter) {
            onCartInfo({
                ...cart,
                total: cart.total_with_discount + cart.extra_tax,
                empty: cart?.items?.length === 0,
            });
        }
    }

    useEffect(() => {
        if (isStoreCounter && !getCart) {

            let intervalToReloadCart: NodeJS.Timeout | null = null;

            const getShowCart = async () => {
                const payload = {
                    cart_id: cartDisplay.id,
                    store_id: currentStore.id,
                    order_type: Number(getOrderTypeIdByName(orderType)),
                    view: isCheckout ? 'checkout' : null,
                }
                try {
                    const cartService = new CartService(orderType);
                    let responseCartShow = await cartService.show(payload);

                    if (responseCartShow) {
                        if (responseCartShow.status === CART_STATUS_FINISHED) {
                            if (parseInt(responseCartShow.order?.status) === ORDER_STATUS_DONE) {
                                cartFinished({
                                    id: cartDisplay.id,
                                    display_id: cartDisplay.display_id ? Number(cartDisplay.display_id) : null,
                                    order: responseCartShow.order
                                });
                                setShowCart(false);
                                setCashier(null);
                                navigate(`${getLinkToHome()}`);
                            } else {
                                setCart(responseCartShow);
                            }
                        } else {
                            handleCartInfo(responseCartShow);

                            setCartDisplay({
                                ...cartDisplay,
                                display_id: responseCartShow.display_id ? Number(responseCartShow.display_id) : null,
                            });

                            const storedCartDisplay = localStorage.getItem('cart_display');

                            if (storedCartDisplay) {
                                const parsedCartDisplay = JSON.parse(storedCartDisplay);
                                const isSameCart = responseCartShow.id === parsedCartDisplay.id;
                                const isDifferentTable = responseCartShow.table?.id !== parsedCartDisplay.table?.id;

                                if (isSameCart && isDifferentTable) {
                                    setCartDisplay({
                                        ...cartDisplay,
                                        display_id: responseCartShow.display_id ? Number(responseCartShow.display_id) : null,
                                        table: {
                                            id: responseCartShow.table?.id,
                                            name: responseCartShow.table?.name,
                                        },
                                    });
                                }
                            } else {
                                setCartDisplay({
                                    ...cartDisplay,
                                    display_id: responseCartShow.display_id ? Number(responseCartShow.display_id) : null,
                                    table: {
                                        id: responseCartShow.table?.id,
                                        name: responseCartShow.table?.name,
                                    },
                                });
                            }
                            setCartFinished(null);
                            setCart(responseCartShow);
                        }


                        if (enablePolling) {
                            if (!intervalToReloadCart) {
                                intervalToReloadCart = setInterval(() => {
                                    getShowCart();
                                }, 10000);
                            }
                        } else {
                            if (intervalToReloadCart) {
                                clearInterval(intervalToReloadCart);
                                intervalToReloadCart = null;
                            }
                        }

                    }
                } catch (error: any) {
                    if (error.response?.data?.error === ERROR_CART_NOT_FOUND) {
                        navigate(`${getLinkToHome()}`);
                        cartNotFound();
                    }
                    setCart(null);
                } finally {
                    setLoading(false)
                }
            }
            if (cartDisplay) {
                getShowCart();

                return () => {
                    if (intervalToReloadCart) {
                        clearInterval(intervalToReloadCart);
                    }
                };
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isStoreCounter])

    useEffect(() => {
        if (getCart) {
            setCart(getCart);
        }
    }, [getCart]);

    useEffect(() => {
        //* informativo para tela de checkout utilizado em onCartInfo()
        if (!getCart) {
            if (!isStoreCounter && currentCart) {
                const currentCartUpdated = {
                    ...currentCart,
                    empty: currentCart?.items?.length === 0
                };
                setCart(currentCartUpdated);
                if (onCartInfo) {
                    onCartInfo(currentCartUpdated)
                }
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentCart]);

    const currentCartRef = useRef(currentCart);
    useEffect(() => {
        if (currentCartRef.current) {
            if (currentCartRef.current.items.length > 0 && currentCart.items.length === 0) {
                onCloseCart();
                return
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [cart]);

    useEffect(() => {
        if (cart) {
            const minimumOrderValue = Number(cart.minimum_order_value) || 0;
            const cartTotal = Number(cart.total_with_discount + cart.extra_tax) || 0;

            setIsCheckoutButtonDisabled(
                (cartTotal === 0 )
                ||  (isDelivery && cartTotal < minimumOrderValue)
                ||  loadingUpdateQuantity
                ? true : false
            )

            setLoading(false);
        }
    }, [cart, loadingUpdateQuantity, isDelivery]);

    const handleResetCart = () => {
        setShowConfirmResetCart(false);
        setShowCart(false);
        const payload = {
            order_type: Number(getOrderTypeIdByName(orderType))
        }
        removeAll(currentCart.cart_id, payload);
    }

    const handleAddMoreProducts = () => {
        onCloseCart(false);
        navigate(`${getLinkToHome()}`);
        if (isCheckout && (isAuthenticated || isAuthenticatedToQuickPurchase)) {
            setReturnToCheckout(true);
        }
    }

    return (
        <section className='px-4 h-full min-h-max'>
            {((loading || loadingCurrentCart))
                ?   <div className="flex items-center justify-center gap-1 h-full text-gray-500"><ImSpinner8 className="animate-spin" /> <span>{isStoreCounter ? t('cart.loading_comanda') : t('cart.loading_cart')}</span></div>
                :
                    cart?.items?.length === 0
                        ?
                            <CartEmpty onCloseCart={() => onCloseCart(false)} />
                        :
                            <section className="flex flex-col justify-between h-full gap-2">

                                {cart && <BoxContentMinimumOrderValue cart={cart} show={showMinimumOrderValue} loading={loadingUpdateQuantity} />}

                                <div className='relative flex flex-col gap-3 w-full h-full md:overflow-y-auto'>
                                    <div className='relative h-full min-h-24' id="boxScroll_cart">
                                        {(cart && (isCheckout || onlyInfo) && cart?.items?.length > 0) &&
                                            <div className="flex items-center justify-between md:mb-4 p-2 pr-0.5 pt-0.5 md:p-2 md:pb-0">
                                                <h2 className="text-sm text-gray-400">{t('cart.items_title')}</h2>
                                            </div>
                                        }
                                        <div className='flex flex-col divide-y divide-gray-100' id='scrollContent_cart'>
                                            {cart?.items?.map((product: any) =>
                                                <CardProductCart
                                                    product={product}
                                                    key={product.id}
                                                    showButtonsIncDec={!isStoreCounter && !onlyInfo && !showButtonEditCart}
                                                    hasExtraTax={cart?.extra_tax > 0}
                                                    showStatus={!onlyInfo}
                                                />
                                            )}
                                        </div>

                                        {cart?.items?.length > 0 &&
                                            <BoxContentEndScrollbars message={t('cart.end_of_list')} />
                                        }

                                        {!onlyInfo &&
                                            <div className="flex items-center justify-between p-2 pt-0">

                                                <button onClick={handleAddMoreProducts} className='inline-flex items-center justify-end gap-0.5 text-xs text-custom-primary hover:opacity-75 font-semibold transition-all'>
                                                    <TbShoppingBagPlus className="text-sm" /> {t('cart.button_add_more_product_label')}
                                                </button>

                                                {(!isStoreCounter && !isCheckout && cart?.items?.length > 1) &&
                                                    <div className='text-right'>
                                                        <button onClick={() => setShowConfirmResetCart(true)}
                                                            className='inline-flex items-center justify-end gap-0.5 text-xs text-gray-400 hover:text-shopfood-danger font-medium transition-all'
                                                            >
                                                            <TbTrash className="text-sm" /> {t('cart.button_remove_all_label')}
                                                        </button>
                                                    </div>
                                                }
                                            </div>
                                        }

                                    </div>
                                </div>

                                <div className={`grid gap-4 w-full sticky bottom-0 bg-white/75 backdrop-blur-sm pt-2`}>

                                    {/* FIDELITY POINTS - MOVE FROM CHECKOUT */}
                                    { (company?.fidelity?.active && Number(company?.fidelity?.rescue_type) === 2 && 
                                        user?.on_fidelity_program && 
                                        (Number(user?.all_points ?? (typeof user?.fidelity_points === 'number' ? user?.fidelity_points : 0)) > 0) && 
                                        !cart?.amount_points && isCheckout) && (
                                            <CardBoxCheckout 
                                                icon={<RiCoinsFill size={25} />} 
                                                loading={loadingFidelity} 
                                                loadingButton 
                                                className="mb-2 text-custom-primary p-2 pr-3"
                                            >
                                                <div className="flex gap-2 items-center w-full" onClick={onOpenFidelity}>
                                                    <div className="flex flex-col w-full gap-1">
                                                        <span className="font-bold leading-none">{t('checkout.fidelity.use_points_title')}</span>
                                                        <div className="flex-inline items-center text-sm leading-none">
                                                            <span className="font-extrabold mr-1">
                                                                {Number(user.all_points ?? (typeof user?.fidelity_points === 'number' ? user?.fidelity_points : 0)) - Number(cart?.amount_points || 0)} 
                                                            </span>
                                                            <span className="text-gray-500 font-medium">
                                                                {company.fidelity.currency_name} {t('checkout.fidelity.available')}
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <ButtonPrimary outline onClick={onOpenFidelity} className="max-h-max">
                                                        {t('layout.button_use_label')}
                                                    </ButtonPrimary>
                                                </div>
                                            </CardBoxCheckout>
                                        )
                                    }

                                    {cart && <CartValueDetails cart={cart} order={order} />}
                                    {(!onlyInfo && !isCheckout) &&
                                        <div className='flex gap-2 pb-4'>
                                            <Button rounded onClick={handleAddMoreProducts}>
                                                <span><TbShoppingBagPlus size={20} /></span>
                                            </Button>
                                            <ButtonPrimary
                                                disabled={isCheckoutButtonDisabled}
                                                onClick={handleCheckout}
                                                className='w-full'
                                                >
                                                {t('cart.button_continue_to_checkout_label')}
                                            </ButtonPrimary>
                                            <Button rounded onClick={() => onCloseCart(false)}>
                                                <span><HiXMark size={20} /></span>
                                            </Button>
                                        </div>
                                    }

                                    {showDoneEditingButton &&
                                        <ButtonPrimary
                                            className='w-full mb-4'
                                            onClick={() => {
                                                setShowCart(false);
                                                setShowDoneEditingButton(false);
                                            }}>
                                            {t('cart.button_continue_payment_label')}
                                        </ButtonPrimary>
                                    }

                                </div>
                            </section>
            }

            <Modal open={showConfirmResetCart} className="max-w-md m-4" onClose={() => setShowConfirmResetCart(false)}>
                <Confirm
                    onConfirm={handleResetCart}
                    onCancel={() => setShowConfirmResetCart(false)}
                    title={t('cart.confirm_remove_all.title')}
                    message={t('cart.confirm_remove_all.message')}
                    labelConfirm={t('cart.confirm_remove_all.label_confirm')}
                />
            </Modal>
        </section>
    );
};

export default Cart;
